module.exports = __webpack_public_path__ + "img/g.371ef470.jpg";